import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {TermsModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createTermsService(dto: TermsModel) {
  return await axios.post<ResponseObject<TermsModel>>(`${BASEURL}/terms/createTerms`, dto)
}
